/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { banquetCartComboGroupSchema } from "./banquetCartComboGroupSchema.ts";

export const banquetCartComboSchema = z.object({
	id: z.uuid(),
	amount: z.int(),
	groups: z.array(banquetCartComboGroupSchema),
});
